import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Menu, X, Activity } from "lucide-react";
import SearchBar from "@/components/SearchBar";
import ThemeToggle from "@/components/ThemeToggle";
import { Button } from "@/components/ui/button";

export default function Header() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const handlePick = (slug) => {
    setOpen(false);
    navigate(`/calculators/${slug}`);
  };

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-40 w-full border-b border-border/70 bg-background/80 backdrop-blur supports-[backdrop-filter]:bg-background/60"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <div className="flex h-16 items-center gap-4">
          <Link
            to="/"
            data-testid="brand-link"
            className="flex items-center gap-2 shrink-0 group"
          >
            <span className="inline-flex h-8 w-8 items-center justify-center rounded-lg bg-primary text-primary-foreground">
              <Activity className="h-4 w-4" />
            </span>
            <span className="font-bold text-lg tracking-tight">
              Fitness<span className="text-muted-foreground font-medium">Calculator</span>
            </span>
          </Link>

          <div className="hidden md:flex flex-1 max-w-xl mx-auto">
            <SearchBar onPick={handlePick} testIdPrefix="header" />
          </div>

          <nav className="hidden md:flex items-center gap-1 shrink-0" aria-label="Primary">
            <Link to="/" className="px-3 py-2 text-sm font-medium hover:text-foreground text-muted-foreground" data-testid="nav-home">Home</Link>
            <Link to="/about" className="px-3 py-2 text-sm font-medium hover:text-foreground text-muted-foreground" data-testid="nav-about">About</Link>
            <Link to="/contact" className="px-3 py-2 text-sm font-medium hover:text-foreground text-muted-foreground" data-testid="nav-contact">Contact</Link>
            <ThemeToggle testId="theme-toggle" />
          </nav>

          <div className="md:hidden flex items-center gap-1 ml-auto">
            <ThemeToggle testId="theme-toggle-mobile" />
            <Button
              variant="ghost"
              size="icon"
              data-testid="mobile-menu-toggle"
              aria-label="Toggle menu"
              onClick={() => setOpen((v) => !v)}
            >
              {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
            </Button>
          </div>
        </div>

        {open && (
          <div className="md:hidden pb-4 space-y-3" data-testid="mobile-menu">
            <SearchBar onPick={handlePick} testIdPrefix="mobile" />
            <nav className="flex flex-col gap-1" aria-label="Mobile">
              <Link to="/" onClick={() => setOpen(false)} className="px-3 py-2 rounded-md hover:bg-accent">Home</Link>
              <Link to="/about" onClick={() => setOpen(false)} className="px-3 py-2 rounded-md hover:bg-accent">About</Link>
              <Link to="/contact" onClick={() => setOpen(false)} className="px-3 py-2 rounded-md hover:bg-accent">Contact</Link>
              <Link to="/disclaimer" onClick={() => setOpen(false)} className="px-3 py-2 rounded-md hover:bg-accent">Disclaimer</Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
